//Comentario necesario para codificación en UTF-8, ver Inc6743
'use strict';

(function() {
	angular.module('pphhApp')
		.controller('UserController', ['$scope', "$window", "$mdDialog", "UserService", "pphhEnv", "CommonCatalogService",
			UserController])
		.controller("openAdmResponsableDialogController", ["$scope", "$mdDialog", "$http", "roleName",
			OpenAdmResponsableDialogController])
		.controller("openCcaaDialogController", ["$scope", "$mdDialog", "$http",
			OpenCcaaDialogController])
			.controller("openDhDialogController", ["$scope", "$mdDialog", "$http",
				OpenDhDialogController])
		.controller("dialogShowRolesController", ["$scope","$filter", "$mdDialog", "roles",
				DialogShowRolesController])			
		;

	function UserController($scope, $window, $mdDialog, UserService, pphhEnv, commonCatalogService) {
		$scope.pageSize = 10;
		var vm = this;

		vm.isLoading = false;
		
		// VARIABLES
		vm.user = {
			id: null,
			nif: null,
			nombre: null,
			apellido1: null,
			apellido2: null,
			email: null,
			emailConfirm: null,

			estado: null,
			feEstado: null,

			ultimoAcceso: null,
			feUltimoAcceso: null,

			isSelected: false,

			roles: [],
		};


		vm.users = [];
		vm.estados = {};

		//CheckBox
		vm.data = {};
		vm.data.cbUltimoAcceso = true;

		vm.submit = submit;
		vm.validaEmail = validaEmail;
		 
		

		vm.search = search;
		vm.activDesactivUser = activDesactivUser;
		vm.init = init;
		vm.getUser = getUser;
		vm.cancel = cancel;
		
		vm.openRols = openRols;
		/*
		 * Funciones genericas
		 */
		vm.showAlertFormWithErrors = showAlertFormWithErrors;
		vm.resetDialog = resetDialog;

		vm.openAdmResponsableDialog = openAdmResponsableDialog;
		
		$scope.doFilter = doFilter;
		$scope.download = download;

		/*
		 * Carga inicial de datos
		 */
		getDemarcaciones();		
		getRoles();
		getEstados();
		
		//------------------------------------------------------------------------------

		vm.selectedRole = 0;
		vm.addPerfil = addPerfil;
		vm.borrarPerfil = borrarPerfil;


		function addPerfil() {
			let perfil = {
				//roleName:  Object.keys($scope.roles)[0],
				roleName: Object.keys(vm.roles)[0],
				administrations: [],
				ccaas: [],
				dhs: [],
				allDhs: false,
				technicalAssistance: false,
			};
			vm.user.roles.push(perfil);
		}
		function borrarPerfil(indice) {
			if (vm.user.roles.length > 1) {
				vm.user.roles.splice(indice, 1);
			}
		}
		//-----------------------------------------------------------------------
		function search() {
			SmartTableUtils.reset(vm.vmTable.tableState());

			vm.vmTable.pipe();
		}

		/*
		 * Paginacion
		 */
		function doFilter(tableState, ctrl) {
			if (!vm.vmTable && ctrl) {
				vm.vmTable = ctrl;
			}

			if (!tableState && vm.vmTable) {
				vm.vmTable.pipe();
				return;
			}

			allUsersReg(tableState);
		}

		function submit() {
			let isError = false;
			let roles = [];
			// comprobacion de roles duplicados
			let strRoles = vm.user.roles.map( e=>e.roleName).join(",");
			angular.forEach(vm.user.roles, function(rol) {
				let regex = new RegExp(rol.roleName, 'g');
				let coincidencias =strRoles.match(regex);
				if ( coincidencias.length > 1 ){	
					isError = true;				
				}
			});
			if ( isError === true){
				var alert = $mdDialog.alert({
					title: UIMessages.dialog.confirm.title,
					textContent: UIMessages.usuario.rolDuplicado,
					ok: UIMessages.dialog.confirm.cerrar
				});
				$mdDialog.show(alert);
				return;
			}
			angular.forEach(vm.user.roles, function(rol) {
				// Debido a que dhuserinfo no contiene los mismo campos que el combo de demarcaciones debido a los cambios para consulta por
				// demarcaciones, hay que asignar los valores antes
				if (!$scope.usuarioForm.$valid ){
					isError = true;
				}
			
				if ( !validateAdministrations(rol) || !validateCoordinadorDh(rol) || !validateConsultaDhs(rol)) {
					isError = true;					
					roles.push(vm.roles[rol.roleName]);
				}					
								
			});
			if ( isError === true){
				showAlertFormWithErrors( roles )
				return;
			}
			

			vm.isLoading = true;
			if (vm.user.id === null) {
				createUser(vm.user);
			} else {
				updateUser(vm.user);
			}
		}
		function validateCoordinadorDh(rol) {
			if (rol.roleName === 'PPHH_COORDINADOR') {
				if ( !rol.dhs || rol.dhs.length!=1 ){
					return false;
				}
			}
			return true;
		}
		function validateConsultaDhs(rol) {
			if (rol.roleName === 'PPHH_CONSULTA') {
				if (rol.dhs.length == 0) {
					return false;
				}
			}
			return true;    
		}

		function validateAdministrations(rol) {
			if (rol.roleName === 'PPHH_AUTORIDAD_CUENC') {
				if (rol.administrations.length === 0) {
					return false;
				} else {
					let errorFound = false;

					angular.forEach(rol.administrations, function(admonInfo) {
						if (rol.technicalAssistance && admonInfo.validTo == null) {
							errorFound = true;
						}
					});

					return !errorFound;
				}
			} else if (rol.roleName === 'PPHH_CCAA_ARU') {
				return!(rol.ccaas.length == 0) 
			} else {
				return true;
			}
		}

		function updateUser(user) {
			vm.isLoading = true;
			UserService.updateUser(user)
				.then(
					function(response) {
						var alert = $mdDialog.alert({
							title: response.data.title,
							textContent: response.data.textContent,
							ok: response.data.ok
						});

						$mdDialog.show(alert)
							.finally(function() {
								vm.isLoading = false;
								getUser(user.id);
							});
					},

					function(response) {
						
						if(response != null && response != undefined && response.data.ErrorMessage) {
							var alert = $mdDialog.alert({
								title: response.data.title,
								textContent: response.data.textContent,
								ok: response.data.ok
							});

							$mdDialog.show(alert);
							vm.isLoading = false;
							return false;
						} 
						
						var alert = $mdDialog.alert({
							title: UIMessages.dialog.info.title,
							textContent: UIMessages.usuario.noActualiza,
							ok: UIMessages.dialog.confirm.cerrar
						});

						$mdDialog.show(alert);

						vm.isLoading = false;
					}
				);
		}

		function createUser(user) {
			vm.isLoading = true;
			UserService.createUser(user)
				.then(
					function(response) {
						var alert = $mdDialog.alert({
							title: response.data.title,
							textContent: response.data.textContent,
							ok: response.data.ok
						});

						$mdDialog.show(alert)
							.finally(function() {
								vm.isLoading = false;
								$window.location.href = pphhEnv.global.contextPath + "/gdu/user/add-template";
							});
					},

					function(errResponse) {
						var alert = null;
						if (errResponse.status === 409) {
							alert = $mdDialog.alert({
								title: errResponse.data.title,
								textContent: errResponse.data.textContent,
								ok: errResponse.data.ok
							});
						} else {
							alert = $mdDialog.alert({
								title: UIMessages.dialog.info.title,
								textContent: UIMessages.usuario.guardar,
								ok: UIMessages.dialog.confirm.cerrar
							});
						}

						$mdDialog.show(alert);

						vm.isLoading = false;
					}
				);
		}

		function allUsersReg(tableState) {

			if (!tableState) {
				tableState = vm.vmTable.tableState();
			}

			vm.isLoading = true;			
			var filter = SmartTableUtils.copyAndSetGenericPaginationParams(tableState, vm.user);			
			UserService.getAllUsersRegistrados(filter)
				.then(
					function(response) {
						$scope.filterResults = response.data.results;
						SmartTableUtils.updateTableState(tableState, response.data);
						vm.isLoading = false;
					},
					function() {
						var alert = $mdDialog.alert({
							title: UIMessages.dialog.info.title,
							textContent: UIMessages.usuario.permitido,
							ok: UIMessages.dialog.confirm.cerrar
						});

						$mdDialog.show(alert);

						vm.isLoading = false;
					}
				);
		}

		function resetDialog() {
			vm.user.admResponsable = '';
		}


		function download() {
			var tableState = vm.vmTable.tableState();
			var filter = SmartTableUtils.copyAndSetGenericPaginationParams(tableState, vm.user);

			UserService.getAllUsersRegistradosExcel(filter);
		}

		//------------------------------------------------------------FUNCIONES GENERICAS------------------------------------------------------------------------------//

		/**
		 * Redireccion de pantallas
		 */
		$scope.go = function go(url) {
			$window.location.href = url;
		}

		function getRoles() {
			vm.roles = {};

			UserService.getRolesUsers()
				.then(
					function(d) {
						vm.roles = d;						
						vm.addPerfil();
					}
				);
		}

		function getEstados() {
			vm.user.estado = '';
			// 1 - pendiente de validar, 2 - activo, 3 - inactivo, 4 - rechazado, 5 - oculto (sistema)
			vm.estados = [{ id: 2, value: "Activo" }, { id: 3, value: "Inactivo" }];
			vm.estados.map(function(estado) { return { value: estado }; });
		}
		function getDemarcaciones() {			
			vm.dhs = [];
			commonCatalogService.getDemarcaciones().then(
				function(response) {
					vm.dhs = response.data;
				});
		}
		function validaEmail() {
			var alert = $mdDialog.alert({
				title: UIMessages.dialog.confirm.title,
				textContent: UIMessages.usuario.correos,
				ok: UIMessages.dialog.confirm.cerrar
			});

			if (vm.user.email !== vm.user.emailConfirm) {
				vm.user.emailConfirm = '';
				$mdDialog.show(alert);
			}
		}

		function showAlertFormWithErrors(roles) {
			let strRoles = "";
			if ( Object.keys (roles).length > 0 ){
				strRoles = ": " + roles.join(',');
			}
			var alert = $mdDialog.alert({
				title: UIMessages.dialog.confirm.title,
				textContent: UIMessages.usuario.formulario + strRoles,
				ok: UIMessages.dialog.confirm.cerrar
			});
			return $mdDialog.show(alert);
		}

		function getUser(id) {
			$window.location.href = pphhEnv.global.contextPath + "/gdu/user/" + id + "/template";
		}
		function init(id) {			
			if (id != null) {
				vm.coordinadordh = {};
				vm.isLoading = true;
				UserService.getUser(id)
					.then(function(response) {
						vm.user = response.data;
						vm.isLoading = false;
					}, function (response){
						vm.isLoading = false;
					}
				);
			}
		}

		function cancel() {
			$window.location.href = pphhEnv.global.contextPath + "/gdu/users/template";
		}

		function activDesactivUser(id, newState) {
			vm.isLoading = true;

			UserService.updateStateUser(id, newState)
				.then(
					function(response) {
						var alert = $mdDialog.alert({
							title: response.data.title,
							textContent: response.data.textContent,
							ok: response.data.ok
						});
						$mdDialog.show(alert)
							.finally(function() {
								vm.isLoading = false;
								getUser(id);
							});
					},

					function() {
						//Cargamos los usuarios
						allUsersReg();
						var alert = $mdDialog.alert({
							title: UIMessages.dialog.confirm.title,
							textContent: UIMessages.usuario.noActualiza,
							ok: UIMessages.dialog.confirm.cerrar
						});
						$mdDialog.show(alert);

						vm.isLoading = false;
					});
		}
		function openAdmResponsableDialog(roleName) {

			$mdDialog.show({
				clickOutsideToClose: true,
				controller: "openAdmResponsableDialogController",
				parent: angular.element(document.body),
				templateUrl: "/cc/adm-dialog/template",
				resolve: {
					roleName: function() {
						return roleName;
					}
				}
			})
			.then(
				function(selected) {
					
					if ( !vm.user.administrations ){
                    	vm.user.administrations = [];
                    }

                    if (!vm.user.administrations.isNull && vm.user.administrations.length > 0) {
                    	vm.user.administrations.splice(0, vm.user.administrations.length);
                    }

                    vm.user.administrations.push({adminId:selected.key, admResponsable:selected.value});
				}
			);
		}
		// 28005 popup para roles
		function openRols(user) {

			$mdDialog.show({
				clickOutsideToClose: true,
				parent: angular.element(document.body),
				locals: {
					roles: user.roles
				},
				controller: "dialogShowRolesController",
				templateUrl: "/gdu/user/dialog-rols-template"
			});
		}
	}

	function OpenAdmResponsableDialogController($scope, $mdDialog, $http, roleName) {

		$scope.sourceResults = {};
		$scope.filtroAdmResponsable = {};

		$scope.selectOnSource = function(row) {
			$mdDialog.hide({ key: row.admId, value: row.admCompetente.key + " - " + row.admCompetente.value });
		};

		$scope.lookup = function() {
			var tableState = $scope.stCtrl.tableState();
			tableState.pagination.start = 0;
			$scope.stCtrl.pipe();
		}

		$scope.doLookup = function(tableState, ctrl) {
			if (!$scope.stCtrl && ctrl) {
				$scope.stCtrl = ctrl;
			}

			if (!tableState && $scope.stCtrl) {
				$scope.stCtrl.pipe();
				return;
			}

			if (!$scope.lookupForm.$valid) {
				return;
			}

			var filter = SmartTableUtils.copyAndSetGenericPaginationParams(tableState, $scope.filtroAdmResponsable);
			filter.roleName = roleName;

			$http({
				method: "GET",
				url: "/cc/adm-dialog",
				params: filter
			})
				.then(
					function(response) {
						var queryResults = response.data;
						if (response.data.results) {
							$scope.sourceResults = queryResults.results;
							$scope.sourcePageSize = queryResults.pageSize;
							SmartTableUtils.updateTableState(tableState, queryResults);
						}
					}
				);
		};
	}

	function OpenCcaaDialogController($scope, $mdDialog, $http) {

		$scope.sourceResults = {};
		$scope.filtroCcaa = {};

		$scope.selectOnSource = function(row) {
			$mdDialog.hide({ key: row.ccaaId, value: row.ccaa.key + " - " + row.ccaa.value });
		};

		$scope.lookup = function() {
			var tableState = $scope.stCtrl.tableState();
			tableState.pagination.start = 0;
			$scope.stCtrl.pipe();
		}

		$scope.doLookup = function(tableState, ctrl) {
			if (!$scope.stCtrl && ctrl) {
				$scope.stCtrl = ctrl;
			}

			if (!tableState && $scope.stCtrl) {
				$scope.stCtrl.pipe();
				return;
			}

			if (!$scope.lookupForm.$valid) {
				return;
			}

			var filter = SmartTableUtils.copyAndSetGenericPaginationParams(tableState, $scope.filtroCcaa);

			$http({
				method: "GET",
				url: "/cc/ccaa-dialog",
				params: filter
			})
				.then(
					function(response) {
						var queryResults = response.data;
						if (response.data.results) {
							$scope.sourceResults = queryResults.results;
							$scope.sourcePageSize = queryResults.pageSize;
							SmartTableUtils.updateTableState(tableState, queryResults);
						}
					}
				);
		};
	}

	function OpenDhDialogController($scope, $mdDialog, $http) {

		$scope.sourceResults = {};
		$scope.filtroDh = {};

		$scope.selectOnSource = function(row) {

			if (row === '-1') {
				$mdDialog.hide({ key: "-1", value: " TODAS LAS DEMARCACIONES " });
			}
			else {
				$mdDialog.hide({ key: row.dhId, value: row.dh.key + " - " + row.dh.value });
			}


		};

		$scope.lookup = function() {
			var tableState = $scope.stCtrl.tableState();
			tableState.pagination.start = 0;
			$scope.stCtrl.pipe();
		}

		$scope.doLookup = function(tableState, ctrl) {
			if (!$scope.stCtrl && ctrl) {
				$scope.stCtrl = ctrl;
			}

			if (!tableState && $scope.stCtrl) {
				$scope.stCtrl.pipe();
				return;
			}

			if (!$scope.lookupForm.$valid) {
				return;
			}

			var filter = SmartTableUtils.copyAndSetGenericPaginationParams(tableState, $scope.filtroDh);

			$http({
				method: "GET",
				url: "/cc/dh-dialog",
				params: filter
			})
				.then(
					function(response) {
						var queryResults = response.data;
						if (response.data.results) {
							$scope.sourceResults = queryResults.results;
							$scope.sourcePageSize = queryResults.pageSize;
							SmartTableUtils.updateTableState(tableState, queryResults);
						}
					}
				);
		};
	}

	function DialogShowRolesController($scope,$filter, $mdDialog, roles) {
		
		$scope.transformData = transformData;
		
		$scope.roles = $scope.transformData ($filter('orderBy')(roles, 'role', false) );
		
		$scope.closeDialog = function() {
			$mdDialog.hide();
		};
		
		function transformData (listaRoles ){		
			var result = [];
			angular.forEach ( listaRoles, function ( value, key){
				var fila = {
							"role":value.role,
							"dhs": [],
						   	"ccaas": "",
						   	"administrations":{} 	
				};
				
				if ( value.dhs.length > 0 ){				
					if ( value.dhs.length == 25 ){
						fila.dhs.push( UIMessages.usuario.todasDh);
					}
					else{
						angular.forEach ( value.dhs, function(value,key){
							fila.dhs.push (value.nombreDh);						
						});

					}					
				}
				if ( value.ccaas.length > 0 ){
					angular.forEach ( value.ccaas, function(value,key){
						fila.ccaas = fila.ccaas + value.nombre + ","; 
					});
					fila.ccaas = fila.ccaas.substring(0, fila.ccaas.length - 1);
				}	
				if ( value.administrations.length>0){
					angular.forEach ( value.administrations, function(valueAdm,key){
						fila.administrations = {"admResponsable": valueAdm.admResponsable,
									"validFrom": valueAdm.validFrom,
									"validTo":valueAdm.validTo
						};						
						if (valueAdm.admScope.length > 0 ){
							angular.forEach ( valueAdm.admScope, function(valueAdmScope,key){
								if( valueAdmScope.checked == true ){
									fila.dhs.push( valueAdmScope.value );
								}
							});							
						}
						
						result.push(fila);
						fila = {
									"role":"",
									"dhs": [],
								   	"ccaas": "",
								   	"administrations":{}  	
						};
					});
				}	
				else{
					result.push(fila);
				}		
			});			
			return result;
		}
	}	
})();
